var _ellipse, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialNetworks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 61,
    viewBox: "0 0 68 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 39,
    rx: 22.5,
    ry: 17,
    fill: "#5AC8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 59.3574V48.7709C62.5 47.9925 61.6501 47.5126 60.9836 47.9145L51.5313 53.615C50.8616 54.0188 50.8938 55.0005 51.5886 55.3596L61.0408 60.2457C61.7064 60.5898 62.5 60.1066 62.5 59.3574Z",
    fill: "#5AC8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 48.5C46.1866 48.5 59.5 38.2737 59.5 25C59.5 11.7263 46.1866 1.5 30.5 1.5C14.8134 1.5 1.5 11.7263 1.5 25C1.5 38.2737 14.8134 48.5 30.5 48.5Z",
    fill: "#EB5081",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 48.3503V38.7794C10 37.9992 10.8535 37.5196 11.5199 37.9252L19.9866 43.0788C20.6516 43.4836 20.6194 44.4595 19.9292 44.8196L11.4626 49.2369C10.7968 49.5843 10 49.1013 10 48.3503Z",
    fill: "#EB5081"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 22.2324C41 26.0335 33.5084 31.9774 31.1812 33.7321C30.7906 34.0267 30.2481 33.986 29.8813 33.6623C27.1564 31.2568 20 25.9028 20 22.2332C20 17.5128 24.9002 13.2392 29.6548 18.2433C30.1071 18.7193 30.8929 18.719 31.3477 18.2454C36.1015 13.2951 41 17.9856 41 22.2324Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNetworks);
export default __webpack_public_path__ + "static/media/social-networks.9246f8409b5ea9b21488e3bf08f66c16.svg";
export { ForwardRef as ReactComponent };